import React from "react";

const ContactHeader = () => {
  return (
    <>
      {/* Header Start */}
      <div className="container-fluid" style={{ backgroundColor: "transparent" }}>
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h3
            className="display-3 mb-4"
            data-aos="fade-down"
            data-aos-delay="100"
            style={{ color: "#A71717" }}
          >
            Contact Us
          </h3>
        </div>
      </div>
      {/* Header End */}

      {/* Google Maps Embed */}
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m22!1m8!1m3!1d3787.1364638263394!2d38.83690752501815!3d8.964305941094462!3m2!1i1024!2i768!4f13.1!4m11!3e2!4m3!3m2!1d8.964433!2d38.8393231!4m5!1s0x164b9b1fa1a0f891%3A0xa7671bb0f5dfd855!2sEchelon%20Outsourcing!3m2!1d8.9643748!2d38.839300099999996!5e1!3m2!1sen!2set!4v1734439168364!5m2!1sen!2set"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Map"
      ></iframe>
    </>
  );
};

export default ContactHeader;
